import React from 'react';
import { Bar } from 'react-chartjs-2';

import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';

import { ChartContainer, ChartHeader, ChartTitle, ChartInfo } from './styles';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const ReportsChart = ({ data = [], year, totalApproved }) => {
    const chartData = {
        labels: Array.isArray(data) ? data.map((item) => item.month) : [],
        datasets: [
            {
                label: 'Visitas Previstas',
                data: Array.isArray(data) ? data.map((item) => item.visitsPlanned) : [],
                backgroundColor: '#10B7DC'
            },
            {
                label: 'Relatórios Aprovados',
                data: Array.isArray(data) ? data.map((item) => item.approved) : [],
                backgroundColor: '#62C054'
            },
            {
                label: 'Relatórios com pendências',
                data: Array.isArray(data) ? data.map((item) => item.pending) : [],
                backgroundColor: '#ED9F4A'
            }
        ]
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'bottom',
                labels: {
                    usePointStyle: true,
                    pointStyle: 'circle',
                    padding: 30,
                    boxWidth: 10,
                    boxHeight: 10
                }
            },
            datalabels: {
                display: false
            }
        },
        scales: {
            x: {
                grid: {
                    display: false
                }
            },
            y: {
                beginAtZero: true,
                grid: {
                    color: '#f0f0f0'
                }
            }
        }
    };

    return (
        <ChartContainer>
            <ChartHeader>
                <ChartTitle>Relatórios criados</ChartTitle>
                <ChartInfo>
                    <span className="year">{year}</span>
                    <span className="separator">|</span>
                    <span className="total">{totalApproved} relatórios aprovados</span>
                </ChartInfo>
            </ChartHeader>
            <div style={{ height: '300px', minWidth: '800px' }}>
                <Bar data={chartData} options={options} />
            </div>
        </ChartContainer>
    );
};

export default ReportsChart;
